import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export interface PricingTierFeatureDetail {
  key: string
  name: string
  description: string | null
  category: string
  icon: string | null
  isUnitPriced?: boolean
  unitPriceHt?: number | null
  unitLabel?: string | null
  pricingNote?: string | null
}

export interface PricingTier {
  id: string
  tier_key: string
  tier_name: string
  tier_description: string | null
  tier_order: number
  price_monthly_ht: number
  checkout_url: string
  is_featured: boolean
  cta_text: string
  max_residences: number
  max_users: number
  max_lots: number
  allows_additional_residences: boolean
  additional_residence_price_ht: number | null
  max_additional_residences: number | null
  enabled_features: string[]
  included_features?: PricingTierFeatureDetail[]
  unit_priced_features?: PricingTierFeatureDetail[]
}

export function usePricingTiers() {
  return useQuery<PricingTier[]>({
    queryKey: ['pricing-tiers'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('pricing_table_data')
        .select('*')
        .order('tier_order')

      if (error) {
        console.error('Error fetching pricing tiers:', error)
        throw error
      }

      console.log('Raw pricing data from DB:', data)

      if (!data || data.length === 0) {
        console.warn('No pricing tiers found in database')
        return []
      }

      // Use unknown to bypass Json type incompatibility with PricingTierFeatureDetail[]
      return data as unknown as PricingTier[]
    },
    staleTime: 5 * 60 * 1000, // Cache 5min
  })
}
